import { HydratedFallbackAsset } from "@zapier/client";
import { useTranslations } from "@zapier/i18n";
import AssetRow from "./AssetRow";

interface Props {
  asset: HydratedFallbackAsset;
  folderId?: string;
  /** Whether the surrounding table shows checkboxes, and so needs the column reserved. */
  includeSelectionColumn?: boolean;
  showLastRun?: boolean;
  showLocationColumn?: boolean;
}

/**
 * Row for asset types this build has no dedicated renderer for: no actions and
 * never selectable.
 */
export function AssetRowFallback({
  asset,
  folderId,
  includeSelectionColumn,
  showLastRun,
  showLocationColumn,
}: Props) {
  const tShared = useTranslations("fallbacks");

  return (
    <AssetRow
      allowSelection={false}
      hiddenSelection={!!includeSelectionColumn}
      asset={asset}
      folderZapTableRow={true}
      icon="actionFallback"
      isUntitled={!asset.name}
      showFavoriteButton={false}
      title={asset.name || tShared("untitled-unknown-asset")}
      // The trash index carries no updatedAt; AssetRow falls back to deletedAt.
      updatedAt={undefined}
      folderId={folderId}
      showLastRun={showLastRun}
      showLocationColumn={showLocationColumn}
    />
  );
}
